import {
  LayoutDashboard,
  Store,
  Package,
  ShoppingCart,
  TrendingUp,
  AlertTriangle,
  RefreshCw,
  Bell,
  FileText,
  Users,
  Settings,
  LayoutGrid,
  GitCompare,
  Boxes,
  Link2,
  Copy,
  FolderTree,
  Merge,
  type LucideIcon,
} from "lucide-react";

export interface SubMenuItem {
  key: string;
  label: string;
  icon?: LucideIcon;
  path: string;
  placeholder?: boolean;
}

export interface NavItem {
  key: string;
  label: string;
  icon: LucideIcon;
  path: string;
  submenu?: SubMenuItem[];
  placeholder?: boolean;
}

interface NavSection {
  title: string;
  items: NavItem[];
}

export const navigationSections: NavSection[] = [
  {
    title: "Primary",
    items: [
      {
        key: "dashboard",
        label: "Dashboard",
        icon: LayoutDashboard,
        path: "/",
      },
      { key: "sellers", label: "Sellers", icon: Store, path: "/sellers" },
      {
        key: "catalog",
        label: "Catalog",
        icon: Package,
        path: "/catalog",
        submenu: [
          {
            key: "catalog-overview",
            label: "Overview",
            icon: LayoutGrid,
            path: "/catalog",
          },
          {
            key: "catalog-sync",
            label: "Marketplace Sync",
            icon: RefreshCw,
            path: "/catalog/sync",
          },
          {
            key: "catalog-compare",
            label: "Compare Marketplaces",
            icon: GitCompare,
            path: "/catalog/compare",
          },
          {
            key: "catalog-master-skus",
            label: "Master SKUs",
            icon: Boxes,
            path: "/catalog/master-skus",
          },
          {
            key: "catalog-mapping",
            label: "Attribute Mapping",
            icon: Link2,
            path: "/catalog/mapping",
          },
          {
            key: "catalog-approval-jobs",
            label: "Approval Jobs",
            icon: RefreshCw,
            path: "/catalog/mapping/jobs",
          },
          {
            key: "catalog-publish-errors",
            label: "Publish Errors",
            icon: AlertTriangle,
            path: "/catalog/publish-errors",
          },
          {
            key: "catalog-mapping-review",
            label: "Mapping Review",
            icon: FolderTree,
            path: "/catalog/mapping-review",
          },
          {
            key: "catalog-leaves",
            label: "Leaves",
            icon: Merge,
            path: "/catalog/leaves",
          },
          {
            key: "catalog-duplicates",
            label: "Duplicates",
            icon: Copy,
            path: "/catalog/duplicates",
            placeholder: true,
          },
        ],
      },
      { key: "orders", label: "Orders", icon: ShoppingCart, path: "/orders" },
      {
        key: "performance",
        label: "Performance",
        icon: TrendingUp,
        path: "/performance",
      },
    ],
  },
  {
    title: "Operations",
    items: [
      {
        key: "disputes",
        label: "Disputes & Refunds",
        icon: AlertTriangle,
        path: "/disputes",
      },
      { key: "sync", label: "Sync & Logs", icon: RefreshCw, path: "/sync" },
      {
        key: "notifications",
        label: "Notifications",
        icon: Bell,
        path: "/notifications",
      },
    ],
  },
  {
    title: "System",
    items: [
      {
        key: "marketplaces",
        label: "Marketplaces",
        icon: Store,
        path: "/marketplaces",
      },
      { key: "audit", label: "Audit Log", icon: FileText, path: "/audit" },
      {
        key: "admin-users",
        label: "Admin Users",
        icon: Users,
        path: "/admin-users",
      },
      { key: "settings", label: "Settings", icon: Settings, path: "/settings" },
    ],
  },
];
